import { render, staticRenderFns } from "./GerenciadorAnalisePrecos.vue?vue&type=template&id=2a96a6d5&scoped=true"
import script from "./GerenciadorAnalisePrecos.vue?vue&type=script&lang=js"
export * from "./GerenciadorAnalisePrecos.vue?vue&type=script&lang=js"
import style0 from "./GerenciadorAnalisePrecos.vue?vue&type=style&index=0&id=2a96a6d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96a6d5",
  null
  
)

export default component.exports